import { GalleryStore } from './galleryStore';
import { getStyleParamsWithDefaults } from '@wix/wixstores-client-common-components/dist/src/outOfIframes/defaultStyleParams/getStyleParamsWithDefaults';
import { ProductsService } from '../services/productsService';
import { getStyleParamsWithDefaultsFunc } from '../getStyleParamsWithDefaultsFunc';
import { withPropsSerialization } from '@wix/native-components-infra/dist/src/utils/propsSerializer';
function getInitialProductsCountToFetch(rows, cols) {
    if (rows === void 0) { rows = 6; }
    if (cols === void 0) { cols = 4; }
    return rows * cols;
}
export function galleryController(controllerFactoryConfig) {
    var galleryStore;
    var compId = controllerFactoryConfig.compId, config = controllerFactoryConfig.config, setProps = controllerFactoryConfig.setProps, factoryContext = controllerFactoryConfig.context, type = controllerFactoryConfig.type, reportError = controllerFactoryConfig.reportError;
    var styleParams = config.style.styleParams;
    return {
        pageReady: function () {
            var styleParamsWithDefaults = getStyleParamsWithDefaults(styleParams, function () {
                return getStyleParamsWithDefaultsFunc({ style: { styleParams: styleParams }, dimensions: undefined });
            });
            var initialProductsCount = getInitialProductsCountToFetch(styleParamsWithDefaults.numbers.galleryRows, styleParamsWithDefaults.numbers.galleryColumns);
            var productsService = new ProductsService(factoryContext.siteStore, initialProductsCount, 'Grid Gallery');
            galleryStore = new GalleryStore(styleParamsWithDefaults, config, withPropsSerialization(setProps), factoryContext.siteStore, productsService, compId, type, reportError);
            return galleryStore.setInitialState().catch(reportError);
        },
        updateConfig: function (_$w, _a) {
            var newStyleParams = _a.style.styleParams, newPublicData = _a.publicData;
            galleryStore.updateState(newStyleParams, newPublicData);
        },
    };
}
//# sourceMappingURL=galleryController.js.map